
const Forbidden = () => {
    return <div className="general-page-container">
        <div className="not-found-inner-wrap">
            <div className="not-found-number">Accesso Negato</div>
            <div className="not-found-label">Sembra che tu non abbia i permessi per accedere a questa applicazione. Richiedi l'accesso per visualizzare le pagine.</div>
        </div>
    </div>;
}


export default Forbidden;